import { withStyles } from "@mui/styles";

// MUI Imports
import { Tooltip } from '@mui/material';

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    padding: '15px',
    fontSize: '1em',
    '& p': {
      margin: 0
    }
  },
}))(Tooltip);

export default CustomTooltip
